import React from "react";
import Button from "src/components/general/buttonv3";
import { additionalFeatures } from "src/data/pricingPersonalData";

const AdditionalFeatures = (): React.JSX.Element => {
  return (
    <div className="mt-10 flex w-full flex-col items-center px-4 sm:px-6 lg:px-8">
      <div className="relative flex w-3/4 flex-col items-center">
        <div className="absolute h-px w-full bg-white/25" />
        <div className="-mt-3.5 z-10 bg-black px-4">
          <span className="bg-gradient-to-r from-purple-100 to-blue-400 bg-clip-text font-bold text-sm text-transparent tracking-widest">
            ADDITIONAL FEATURES
          </span>
        </div>
      </div>

      <div className="mt-6 w-3/4 ">
        <div className="w-full lg:hidden">
          <div className="mb-4 grid grid-cols-3 gap-1">
            <button className="rounded bg-brand-slate px-4 py-2 text-center font-medium text-sm">
              Free
            </button>
            <button className="rounded bg-blue-400/20 px-4 py-2 text-center font-medium text-blue-400 text-sm">
              Premium
            </button>
            <button className="rounded bg-purple-100/20 px-4 py-2 text-center font-medium text-purple-100 text-sm">
              Ultimate
            </button>
          </div>

          <div className="space-y-4">
            {additionalFeatures.map((feature, idx) => (
              <div key={idx} className={`rounded p-4 ${idx % 2 === 1 ? "bg-brand-slate" : ""}`}>
                <p className="mb-2 text-center text-base">{feature.name}</p>
                <div className="grid grid-cols-3 gap-2">
                  <div className="flex items-center justify-center">
                    {feature.free === true ? (
                      <span className="icon-[ic--sharp-check] text-2xl text-white" />
                    ) : feature.free === false ? (
                      <span className="icon-[system-uicons--cross] inline-block text-2xl" />
                    ) : (
                      <span className="text-sm opacity-75">{feature.free}</span>
                    )}
                  </div>
                  <div className="flex items-center justify-center">
                    {feature.premium === true ? (
                      <span className="icon-[ic--sharp-check] text-2xl text-blue-400" />
                    ) : feature.premium === false ? (
                      <span className="icon-[system-uicons--cross] inline-block text-2xl" />
                    ) : (
                      <span className="text-sm opacity-75">{feature.premium}</span>
                    )}
                  </div>
                  <div className="flex items-center justify-center">
                    {feature.ultimate === true ? (
                      <span className="icon-[ic--sharp-check] text-2xl text-purple-100" />
                    ) : feature.ultimate === false ? (
                      <span className="icon-[system-uicons--cross] inline-block text-2xl" />
                    ) : (
                      <span className="text-sm opacity-75">{feature.ultimate}</span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="hidden w-full overflow-x-auto lg:block">
          <table className="w-full">
            <thead>
              <tr className=" text-left">
                <th className="w-3/12 px-5 pb-4 font-normal text-base">Feature</th>
                <th className="w-3/12 px-5 pb-4 text-center font-normal text-base">Free</th>
                <th className="w-3/12 px-5 pb-4 text-center font-normal text-base text-blue-400">
                  Premium
                </th>
                <th className="w-3/12 px-5 pb-4 text-center font-normal text-base text-purple-100">
                  Ultimate
                </th>
              </tr>
            </thead>
            <tbody>
              {additionalFeatures.map((feature, idx) => (
                <tr key={idx} className={idx % 2 === 1 ? "bg-brand-slate" : ""}>
                  <td className="px-5 py-4 text-base">{feature.name}</td>
                  <td className="px-5 py-4 text-center">
                    {feature.free === true ? (
                      <span className="icon-[ic--sharp-check] text-2xl" />
                    ) : feature.free === false ? (
                      <span className="icon-[system-uicons--cross] inline-block text-2xl" />
                    ) : (
                      <span className="text-white/75">{feature.free}</span>
                    )}
                  </td>
                  <td className="px-5 py-4 text-center">
                    {feature.premium === true ? (
                      <span className="icon-[ic--sharp-check] text-2xl text-blue-400" />
                    ) : feature.premium === false ? (
                      <span className="icon-[system-uicons--cross] inline-block text-2xl" />
                    ) : (
                      <span className="text-white/75">{feature.premium}</span>
                    )}
                  </td>
                  <td className="px-5 py-4 text-center">
                    {feature.ultimate === true ? (
                      <span className="icon-[ic--sharp-check] text-2xl text-purple-100" />
                    ) : feature.ultimate === false ? (
                      <span className="icon-[system-uicons--cross] inline-block text-2xl" />
                    ) : (
                      <span className="text-white/75">{feature.ultimate}</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className=" mt-8 mb-10 hidden w-full justify-end lg:flex lg:flex-row">
          <div className="items-center" />
          <div className="flex w-3/12 justify-center">
            <Button
              isDisabled={false}
              buttonText="Get Free"
              buttonURL="/account"
              color="brandFree"
              size="md"
            />
          </div>
          <div className="flex w-3/12 justify-center">
            <Button
              isDisabled={false}
              buttonText="Get Premium"
              buttonURL="/account"
              color="brandPremium"
              size="md"
            />
          </div>
          <div className="flex w-3/12 justify-center">
            <Button
              isDisabled={false}
              buttonText="Get Ultimate"
              buttonURL="/account"
              color="brandUltimate"
              size="md"
            />
          </div>
        </div>

        <div className="mt-8 mb-10 flex flex-col justify-between gap-4 sm:flex-row lg:hidden">
          <div className="flex justify-center">
            <Button
              isDisabled={false}
              buttonText="Get Free"
              buttonURL="/account"
              color="brandFree"
              size="sm"
            />
          </div>
          <div className="flex justify-center">
            <Button
              isDisabled={false}
              buttonText="Get Premium"
              buttonURL="/account"
              color="brandPremium"
              size="sm"
            />
          </div>
          <div className="flex justify-center">
            <Button
              isDisabled={false}
              buttonText="Get Ultimate"
              buttonURL="/account"
              color="brandUltimate"
              size="sm"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdditionalFeatures;
